import { Navigate, Outlet, useLocation } from 'react-router'
import { ROUTES } from '../../routes'
import { useAuth } from './session'

/**
 * Pages for signed-out visitors (sign-in, sign-up): once signed in, goes on to
 * the page that sent the visitor here, or to the chat.
 */
export function GuestOnly() {
  const { session } = useAuth()
  const location = useLocation()
  if (session) {
    const from = (location.state as { from?: string } | null)?.from
    return <Navigate to={from ?? ROUTES.chat.path} replace />
  }
  return <Outlet />
}
